import * as Entities from '../../constants/entities';
import { getStatusFilterSelectOptions } from '../../utils/statusUtil';

const quickFilters = [
  {
    name: 'insuredStatus',
    searchKey: 'status',
    data: getStatusFilterSelectOptions(Entities.Insured, ' Insureds'),
    selected: [],
    pageInfo: null,
    placeholder: 'Insured Status',
    idKey: 'value',
    labelKey: 'text'
  }
];

export default quickFilters;
